import { Modal, Radio, Spin } from 'antd';
import { useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { Note, Page, Steps } from '../../../helbest';
import { API } from '../../../request/api';
import { changeAddressId } from '../../../store/actions/payment';
import { ReactComponent as EditIcon } from './../../../assets/svg/edit.svg';
import { ReactComponent as PlusIcon } from './../../../assets/svg/plus.svg';
// icons
import { ReactComponent as LocationIcon } from './../../../assets/svg/send-page-location.svg';
import { ReactComponent as PostalCodeIcon } from './../../../assets/svg/send-page-postal-code.svg';
import { ReactComponent as TrashRedIcon } from './../../../assets/svg/trash-red.svg';
import styles from './Delivery.module.css';
import Footer from './Footer/Footer';
import useDelivery from './useDelivery';

const Delivery = ({ changeAddress }) => {
  const [
    current_address,
    address_list,
    address_list_ref,
    set_current_address,
    loading,
    message,
    getAddresses
  ] = useDelivery();

  const history = useHistory();

  const [modal_visible, set_modal_visible] = useState('');
  const [address_to_delete, set_address_to_delete] = useState(0);

  const modalHandler = (id) => {
    set_modal_visible(id);
  };

  const delete_address = () => {
    set_modal_visible('');
    API.del
      .userAddresses(address_to_delete)
      .then((response) => {
        if (response.success) {
          getAddresses();
          Note.success('آدرس پاک شد');
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  return (
    <Page
      address="/cart/"
      back
      className="page-delivery"
      footer={
        <Footer
          submitClick={() => {
            if (loading) {
              return;
            }
            if (current_address === null) {
              Note.error('آدرسی انتخاب نشده است');
              return;
            }
            changeAddress(current_address);
            history.push(`/payment`);
          }}
        />
      }
      headerFix
      logo
      mobileContainer
      showFooter
      title="انتخاب آدرس">
      <Steps step={2} />

      {/* <div className={styles.MessageBox}>
        <div className="caution-message delivery-item">
          <div className="caution-message-parts">
            با توجه به تعطیلات نوروزی در صورت خرید کالا از امروز تا 14 فروردین
            ماه، موعد تحویل از 20 تا 25 فروردین می باشد.
          </div>
        </div>
      </div> */}
      {message ? (
        <div className={styles.MessageBox}>
          <div className="caution-message delivery-item">
            <div className="caution-message-parts">{message}</div>
          </div>
        </div>
      ) : null}

      <section className="delivery-page-body">
        <div className="container desktop-mode px-0" style={{ paddingBottom: 10 }}>
          {loading ? (
            <div className={styles.Spinner}>
              <Spin />
            </div>
          ) : null}

          {/* {!!current_address && (
            <> */}
          <div className={styles.BoxContainer}>
            <div className={styles.NewAddressButton}>
              <button
                className={styles.EditAddressButton}
                onClick={() => history.push('/address-create/')}
                type="button">
                افزودن آدرس جدید
                <PlusIcon />
              </button>
              <div>مدیریت آدرس ها</div>
            </div>
            <hr style={{ width: '100%', borderBottom: '1px solid #F2F2F2', marginTop: '10px' }} />
            <div
              ref={address_list_ref}
              className={`${styles.ChangeAddressBox} ${!address_list.length ? styles.NoPadding : ''}`}>
              {address_list.map((address_item, address_item_index) => (
                <div key={address_item.id} className={styles.AddressItemContainer}>
                  <div
                    key={address_item.id}
                    className={`${styles.AddressListItem} ${
                      address_item_index === address_list.length - 1 ? styles.LastOne : ''
                    }`}
                    onClick={() => {
                      set_current_address(address_item.id);
                    }}>
                    <div className={styles.AddressItemWrapper}>
                      <div className={styles.ActionButtonsContainer}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          type="button">
                          <Link to={`/address-edit/${address_item.id}/`}>
                            <EditIcon />
                          </Link>
                        </button>
                        <button
                          onClick={() => {
                            modalHandler(address_item.id);
                            set_address_to_delete(address_item.id);
                          }}
                          type="button">
                          <TrashRedIcon />
                        </button>
                      </div>

                      <Modal
                        centered={true}
                        className="address-delete-modal"
                        closable={false}
                        footer={false}
                        visible={modal_visible === address_item.id}>
                        <div className="flex column text-center">
                          <label className="text-center">
                            آیا می خواهید این آدرس را حذف نمایید؟
                          </label>
                          <div className="buttons">
                            <button onClick={() => delete_address()} type="button">
                              بله
                            </button>
                            <button
                              onClick={() => {
                                set_modal_visible('');
                                set_address_to_delete(0);
                              }}
                              type="button">
                              خیر
                            </button>
                          </div>
                        </div>
                      </Modal>

                      <div className={styles.AddressItemDetails}>
                        <div className={styles.AddressValueContainer}>
                          <div className={`${styles.LocationIcon} ${styles.LocationIcon33}`}>
                            <Radio checked={address_item.id === current_address} />
                          </div>
                          <span>{address_item.address}</span>
                        </div>
                        <div className={styles.AddressValueContainer}>
                          <LocationIcon
                            className={`${styles.LocationIcon} ${styles.LocationIcon33}`}
                          />
                          <span className={styles.AddressValue}>{address_item.location}</span>
                        </div>
                        <div className={styles.AddressValueContainer}>
                          <PostalCodeIcon
                            className={`${styles.LocationIcon} ${styles.LocationIcon33}`}
                          />
                          <span className={styles.AddressValue}>{address_item.zip_code}</span>
                        </div>
                        {/* <div className={styles.AddressValueContainer}>
                          <PhoneIcon
                            className={`${styles.LocationIcon} ${styles.LocationIcon33}`}
                          />
                          <span className={styles.AddressValue}>
                            {address_item.phone}
                          </span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* </>
          )} */}
        </div>
      </section>
    </Page>
  );
};

const mapDispatchToProps = (dispatch) => ({
  changeAddress: (id) => dispatch(changeAddressId(id))
});

export default connect(null, mapDispatchToProps)(Delivery);
